import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CurrencyProvider } from "@/contexts/CurrencyContext";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Success from "@/pages/Success";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Subscriptions from "@/pages/Subscriptions";
import SubscriptionSuccess from "@/pages/SubscriptionSuccess";
import Suppliers from "@/pages/Suppliers";
import TermsConditions from "@/pages/TermsConditions";
import RefundPolicy from "@/pages/RefundPolicy";
import BundleBuilder from "@/pages/BundleBuilder";
import "@/App.css";

function App() {
  return (
    <CurrencyProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:id" element={<ProductDetail />} />
            <Route path="/success" element={<Success />} />
            <Route path="/subscriptions" element={<Subscriptions />} />
            <Route path="/subscription/success" element={<SubscriptionSuccess />} />
            <Route path="/suppliers" element={<Suppliers />} />
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/bundle" element={<BundleBuilder />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </CurrencyProvider>
  );
}

export default App;
